import { useState } from 'react';
import { routes } from '@/constants';
import { useNavigate } from '@/hooks/useNavigate';
import { useResidency, type ResidencyAnswer } from '@/hooks/useResidency';
import InAppBrowserBlock from '@/pages/Answers/InAppBrowserBlock.tsx';
import ResidencyBlocked from './ResidencyBlocked';
import ResidencyQuestion from './ResidencyQuestion';

/**
 * The residency gate, shown between the intro video and the first question.
 *
 * Video answers are biometric data under Illinois BIPA and California
 * CCPA/CPRA, and we are not set up to collect them from residents of those
 * states — so declaring residency there is a dead end.
 */
export default function Residency() {
  const navigate = useNavigate();
  const { answer, setAnswer } = useResidency();

  // Distinguishes "the candidate just tapped Continue into the block screen"
  // from "the block screen mounted already-blocked" (reload, back-navigation
  // with ca_il already in sessionStorage). Only the former should steal
  // focus onto the block heading — see ResidencyBlocked's `focusHeadingOnMount`.
  const [justBlocked, setJustBlocked] = useState(false);

  const handleSubmit = (next: ResidencyAnswer) => {
    setAnswer(next);

    if (next === 'other') {
      navigate(routes.questions);
    } else {
      setJustBlocked(true);
    }
  };

  return (
    <>
      <InAppBrowserBlock />
      {answer === 'ca_il' ? (
        <ResidencyBlocked focusHeadingOnMount={justBlocked} />
      ) : (
        <ResidencyQuestion initialAnswer={answer} onSubmit={handleSubmit} />
      )}
    </>
  );
}
